import { useEffect } from 'react';

// icons
import { FaCheck } from 'react-icons/fa6';
import { RiTimeLine } from 'react-icons/ri';
import { RiGroupLine } from 'react-icons/ri';
import { FaRegUser } from 'react-icons/fa6';
import { RiShieldStarLine } from 'react-icons/ri';

// style
import style from './card.module.css';
// component

// animation
import AOS from 'aos';
import 'aos/dist/aos.css';

const Card = ({ item }) => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className={style.card}>
      <div className={style.title}>
        <h3 className={style.name}>{item.Name}</h3>
        <span className={style.desc}>{item.Arena_type}</span>
      </div>
      {/* price  */}
      <div className={style.price}>
        {item.Name == 'Скайпарк' ? (
          <>
            <span className={style.doble}>{item.Price}</span>
            <span className={style.doble}>{item.doble_price}</span>
          </>
        ) : (
          <>
            <b>{item.Price}</b>
            <span>{item.Full_time}</span>
          </>
        )}
      </div>
      {/* detals */}
      <ul className={style.desc}>
        <span className={style.row}>В стоимость включено:</span>
        <li>
          <FaCheck /> <span>Инструктаж</span>
        </li>
        {item.Game_desc && (
          <li>
            <FaCheck />
            <span>{item.Game_desc}</span>
          </li>
        )}
        {item.Equipment && (
          <li>
            <RiShieldStarLine />
            <span>{item.Equipment}</span>
          </li>
        )}
        {item.Time && (
          <li>
            <RiTimeLine />
            <span>{`Длительность - ${item.Time}`}</span>
          </li>
        )}
        {item.Rest_time && (
          <li>
            <RiTimeLine />
            <span>{`Зона отдыха - ${item.Rest_time}`}</span>
          </li>
        )}
        <span className={style.row}>Важно:</span>
        {item.MinGamers && (
          <li>
            <RiGroupLine />
            <span>{`Мин. игроков - ${item.MinGamers}`}</span>
          </li>
        )}
        {item.Age && (
          <li>
            <FaRegUser />
            <span>{`Мин. возраст - ${item.Age}`}</span>
          </li>
        )}
        <span className={style.row}>Дополнительно:</span>
        {item.Ext_time && (
          <li>
            <span>{`Продление - ${item.Ext_time}`}</span>
          </li>
        )}
        {item.Bols && (
          <li>
            <span>{`Доп. шары - ${item.Bols}`}</span>
          </li>
        )}
        {item.additional && (
          <li>
            <span>{item.additional}</span>
          </li>
        )}
      </ul>
    </div>
  );
};
export default Card;
